import React from "react";
import { useLanguage } from "@/lib/i18n";
import LegalLayout from "@/components/legal/LegalLayout";

export default function LegalNotice() {
  const { t } = useLanguage();
  return (
    <LegalLayout titleKey="legal.notice.title" testid="legal-notice-page">
      <Section title={t("legal.notice.s1.title")}>
        <p>{t("legal.notice.s1.body")}</p>
      </Section>
      <Section title={t("legal.notice.s2.title")}>
        <ul className="list-disc pl-5 space-y-1">
          <li>{t("legal.notice.s2.responsible")}</li>
          <li>{t("legal.notice.s2.location")}</li>
          <li>{t("legal.notice.s2.contact")}</li>
        </ul>
        <p className="text-sm text-[#475569] mt-3">
          {t("legal.notice.s2.note")}
        </p>
      </Section>
      <Section title={t("legal.notice.s3.title")}>
        <p>{t("legal.notice.s3.body")}</p>
      </Section>
      <Section title={t("legal.notice.s4.title")}>
        <p>{t("legal.notice.s4.body")}</p>
      </Section>
      <Section title={t("legal.notice.s5.title")}>
        <p>{t("legal.notice.s5.body")}</p>
      </Section>
      <Section title={t("legal.notice.s6.title")}>
        <p>{t("legal.notice.s6.body")}</p>
      </Section>
    </LegalLayout>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-sans-display text-lg text-[#0B2545] tracking-tight mt-8 mb-3">
        {title}
      </h2>
      {children}
    </section>
  );
}
